export default "__VITE_ASSET__BowjeATw__"